import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('client?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('client/show/'+id);
    },    
    create(params) {
        return Service().post('client/create', params);
    },
    update(id, params) {
        return Service().post('client/update/'+id, params);
    },
    delete(id) {
        return Service().post('client/delete/'+id);
    }
}